@use '@/styles/tokens' as *;

.toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: var(--space-3);
}

.filterBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  color: var(--text-secondary);
  background: var(--surface-card);
  border: 1px solid var(--border-default);
  border-radius: 10px;
  cursor: pointer;

  &:hover {
    background: var(--surface-muted);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }
}

/* ── Activity Log card (green gradient) ──────────────────── */
.activityCard {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: var(--space-5);
  margin-bottom: var(--space-6);
  border-radius: 16px;
  color: var(--text-inverse);
  background: linear-gradient(110deg, #3d5b34 0%, #6f7d3a 55%, #aeb94f 100%);
  position: relative;
  overflow: hidden;
}

.activityTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.activityLabel {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
}

.livePill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: var(--font-weight-medium);
  color: $color-brand-950;
  background: $color-accent1-400;
  border-radius: var(--radius-pill);
}

.liveDot {
  width: 6px;
  height: 6px;
  border-radius: var(--radius-pill);
  background: $color-brand-950;
}

.activityCount {
  font-family: #{$font-family-heading};
  font-size: 22px;
  font-weight: var(--font-weight-medium);
  letter-spacing: -0.02em;
}

.activitySub {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
}

/* ── Timeline ────────────────────────────────────────────── */
.timeline {
  list-style: none;
  margin: 0;
  padding: 0;
}

.item {
  position: relative;
  display: grid;
  grid-template-columns: 28px 1fr;
  gap: var(--space-3);
  padding-bottom: var(--space-6);
}

/* dashed connector between dots */
.item:not(.itemLast)::before {
  content: '';
  position: absolute;
  left: 13px;
  top: 24px;
  bottom: 0;
  width: 0;
  border-left: 1px dashed var(--border-default);
}

.itemLast {
  padding-bottom: 0;
}

.dot {
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  color: $color-accent1-800;
  background: var(--surface-card);
  z-index: 1;
}

.itemBody {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.date {
  font-size: 13px;
  color: $color-accent1-800;
}

.itemTitle {
  font-size: 15px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
}

.itemDetail {
  font-size: 14px;
  color: var(--text-muted);
  line-height: 1.35;
}
